import type { AxiosInstance } from "axios";
import {
  ATTACHMENTS_AS_URLS,
  MESSAGE_PAGE_SIZE,
} from "./thread/useEarlierMessages";
import { noteSnapshotRequest } from "./sessionOpenTiming";

// Kept free of transformSession so AuthProvider's deep-link prefetch can
// start the request without pulling the parser into the root bundle.

/** Matches hover prefetch, so a click inside the window never refetches. */
export const ASSISTANT_SESSION_STALE_TIME_MS = 30_000;
/** Opened sessions stay warm so sidebar switching skips the skeleton. */
export const ASSISTANT_SESSION_CACHE_TIME_MS = 15 * 60 * 1000;

export function assistantSessionQueryKey(sessionId: string) {
  return ["assistantSession", sessionId] as const;
}

/** The windowed snapshot the thread renders from, unparsed. */
export function requestAssistantSession(api: AxiosInstance, sessionId: string) {
  noteSnapshotRequest(sessionId);
  return api.get(`/assistant/sessions/${sessionId}`, {
    params: { limit: MESSAGE_PAGE_SIZE, attachments: ATTACHMENTS_AS_URLS },
  });
}
